import type { AxiosResponse } from 'axios'
import axios from 'axios'
import { useSessionStore } from '@/store/session' // Importăm store-ul Pinia

// Tipuri pentru parametri
type Params = Record<string, any>
const apiBaseURL = process.env.VUE_APP_API_BASE_URL

// Creează instanța axios cu setările corespunzătoare
const apiClient = axios.create({
  baseURL: apiBaseURL,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

// Adăugăm un interceptor pentru a injecta `jwt` în header-ul `Authorization`
apiClient.interceptors.request.use(
  (config) => {
    const sessionStore = useSessionStore() // Accesăm store-ul Pinia
    const jwt = sessionStore.jwt // Obținem `jwt` din store

    if (jwt) {
      config.headers.Authorization = `Bearer ${jwt}` // Adăugăm token-ul în header-ul `Authorization`
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Definirea serviciului API
const apiService = {
  // POST
  post<T>(endpoint: string, params: Params): Promise<AxiosResponse<T>> {
    return apiClient.post<T>(endpoint, params)
  },

  // GET (returnează fie un obiect, fie o listă în funcție de endpoint)
  get<T>(endpoint: string, params?: Params): Promise<AxiosResponse<T>> {
    return apiClient.get<T>(endpoint, { params })
  },

  // PUT
  put<T>(endpoint: string, params: Params): Promise<AxiosResponse<T>> {
    return apiClient.put<T>(endpoint, params)
  },

  // DELETE
  delete<T>(endpoint: string): Promise<AxiosResponse<T>> {
    return apiClient.delete<T>(endpoint)
  }
}

export default apiService
